import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";

export async function appVersion(): Promise<string> {
  if (Capacitor.isNativePlatform()) {
    const appInfo = await App.getInfo();
    return `${appInfo.version}${import.meta.env.VITE_STAGE === "prod" ? "p" : "b"}${appInfo.build}`;
  }
  return __APP_VERSION__;
}
